import { render, staticRenderFns } from "./safe-danger-detail.vue?vue&type=template&id=22bd6a7c&scoped=true&"
import script from "./safe-danger-detail.vue?vue&type=script&lang=js&"
export * from "./safe-danger-detail.vue?vue&type=script&lang=js&"
import style0 from "./safe-danger-detail.vue?vue&type=style&index=0&id=22bd6a7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bd6a7c",
  null
  
)

export default component.exports